import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

export const STORE_DETAIL_SECTIONS = [
  {
    id: 'profile',
    title: 'Store profile',
    subtitle: 'Account, contact, and public store display information',
    Icon: StorefrontOutlinedIcon,
  },
  {
    id: 'address',
    title: 'Address & location',
    subtitle: 'Store address, geolocation, and delivery radius',
    Icon: LocationOnOutlinedIcon,
  },
  {
    id: 'hours',
    title: 'Operating hours',
    subtitle: 'Kitchen schedule and restricted delivery windows',
    Icon: AccessTimeOutlinedIcon,
  },
  {
    id: 'menu',
    title: 'Menu availability',
    subtitle: 'Meal offerings and menu visibility settings',
    Icon: MenuBookOutlinedIcon,
  },
  {
    id: 'delivery',
    title: 'Delivery & pickup',
    subtitle: 'Delivery fees, promotions, and driver shortage status',
    Icon: LocalShippingOutlinedIcon,
  },
  {
    id: 'merchant',
    title: 'Merchant package',
    subtitle: 'Processing fees and agreement policy',
    Icon: ReceiptLongOutlinedIcon,
  },
  {
    id: 'onboarding',
    title: 'Onboarding process',
    subtitle: 'Track and update the store onboarding checklist',
    Icon: TaskAltOutlinedIcon,
  },
];
